import createStore from "@Stores/base-factories"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionFactory('cms/tag')
  .extendHookCollectionsFactory('cms/tags')
  .factory()

export {
  Provider as TagProvider,
  useStore as useTagStore,
}
